import { http, httpV2 } from "@/api";

/**
 * @summary Solicita o resultado do diagnóstico do estágio 2 para o conjunto de resultado.
 * @param {number} resultSetId Id do conjunto de resultado.
 * @returns {promise} Retorna status do diagnóstico.
 */
const GetStage2Result = function(resultSetId)
{
	return http.get(`/WindTurbinesDiagnostic/${resultSetId}/GearboxStage2`);
};

/**
 * @summary Solicita os dados para construção do gráfico do estágio 2.
 * @param {number} resultSetId Id do conjunto de resultado.
 * @returns {promise} Retorna os eixos do gráfico e frequências de interesse.
 */
const GetStage2Chart = function(resultSetId, location)
{
	return http.get(`/WindTurbinesDiagnostic/${resultSetId}/${location}/GearboxStage2/Chart`);
};

/**
 * @summary Solicita o resultado do diagnóstico do estágio 3 para o conjunto de resultado.
 * @param {number} resultSetId Id do conjunto de resultado.
 * @returns {promise} Retorna status do diagnóstico.
 */
const GetStage3Result = function(resultSetId)
{
	return http.get(`/WindTurbinesDiagnostic/${resultSetId}/GearboxStage3`);
};

/**
 * @summary Solicita os dados para construção do gráfico do estágio 3.
 * @param {number} resultSetId Id do conjunto de resultado.
 * @returns {promise} Retorna os eixos do gráfico e frequências de interesse.
 */
const GetStage3Chart = function(resultSetId, location)
{
	return http.get(`/WindTurbinesDiagnostic/${resultSetId}/${location}/GearboxStage3/Chart`);
};

/**
 * @summary Obtém as informações dos sinais de um diagnóstico.
 * @param {number} id - Id do diagnóstico.
 * @returns {promise} Promise da chamada da API.
 */
const GetDiagnosticSignalsStageTwo = function(id)
{
	return httpV2.get(`/GearboxStage2BrokenTeethSettings/${id}/Signals`);
};

/**
 * @summary Obtém as informações dos sinais de um diagnóstico.
 * @param {number} id - Id do diagnóstico.
 * @returns {promise} Promise da chamada da API.
 */
const GetDiagnosticSignalsStageThree = function(id)
{
	return httpV2.get(`/GearboxStage3BrokenTeethSettings/${id}/Signals`);
};

export default {
	GetStage2Result,
	GetStage2Chart,
	GetStage3Result,
	GetStage3Chart,
	GetDiagnosticSignalsStageTwo,
	GetDiagnosticSignalsStageThree
};